///jacques-andre-editeur\proshop-v2\frontend\src\screens\NewsScreen.jsx
//import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useGetNewsQuery } from '../slices/newsApiSlice';
import NewsCard from '../components/NewsCard';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Paginate from '../components/Paginate';
import Meta from '../components/Meta';

const NewsScreen = () => {
    const { pageNumber } = useParams();
    
    const [sortConfig, setSortConfig] = useState({
        key: '_id',
        direction: 'desc',
    });

  
  const { data, isLoading, error, refetch } = useGetNewsQuery({
    pageNumber,
    sortKey: sortConfig.key,
    sortDirection: sortConfig.direction,
    parPage:10,
  });

  console.log('data dans le screen NewsScreen.jsx : ', data)

  return (
    <>
      <Meta />
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>
          {error?.data?.message || error.error}
        </Message>
      ) : (
        <Container>
          <div className="h1-container">
            <h1>Actualités</h1>
          </div>
          <div className="news-row">
              {data?.news?.map((news) => (
                  <NewsCard news={news} key={news._id} />
              ))}
            </div>
          <Paginate pages={data.pages} page={data.page} basePath="/news" />
        </Container>
      )}
    </>
  );
};

export default NewsScreen;
